export const preFix = 'bb-$'

export const emptyObject = {}
Object.freeze(emptyObject)

export const currencyCodeMap = {
  HK: 'HKD',
  TW: 'USD',
  MO: 'USD',
  US: 'USD',
  KR: 'KRW',
  JP: 'JPY',
}

export enum EditorFlagEum {
  detail = 'detail',
  preview = 'preview',
  edit = 'edit',
}

// key 值为 语言
export enum LangEum {
  zh = 'zh',
  en = 'en',
  'zh-TW' = 'zh-TW',
  'zh-TW2' = 'zh-TW2',
  'zh-MO' = 'zh-MO',
  ja = 'ja',
  'zh-SG' = 'zh-SG',
  'zh-MY' = 'zh-MY',
  ko = 'ko',
}

// key 值为 地区
export enum LocalEum {
  HK = 'HK',
  JP = 'JP',
  KR = 'KR',
  US = 'US',
  TW = 'TW',
  MO = 'MO',
  SG = 'SG',
  MY = 'MY',
}

// key 值为 地区
export const currencySymbolMap = {
  HK: 'HK$',
  CN: 'HK$',
  US: 'US$',
  TW: 'US$',
  MO: 'US$',
  JP: '￥',
  KR: '₩',
  SG: '$',
  MY: 'US$',
}

export const signKey = '048a9c4943398714b356a696503d2d36'

// 客户端jockey定义的渠道值
export enum ShareChannelMap {
  'wechat' = '0',
  'facebook' = '1',
  'messenger' = '2',
  'whatsapp' = '3',
  'instagram' = '4',
  'copyLink' = '5',
  'twitter' = '6',
}
// 埋点平台定义的渠道值
export enum TrackShareChannelMap {
  '页面在app内部' = '0',
  'facebook' = '1',
  'whatsapp' = '2',
  'instagram' = '3',
  'wechat' = '4',
  'messenger' = '5',
  'copyLink' = '6',
  'twitter' = '7',
}
